import type { UpdatePaymentLimitsRequest } from '../../../generated-types';
import { updatePaymentLimits } from '../../../services/paymentLimitsService';
import { PaymentLimitsState } from './state';

export default (state: PaymentLimitsState) => {
    const request: UpdatePaymentLimitsRequest = {
        maxTransactionAmount: state.maxTransactionAmount!,
        maxMonthlyTransactionAmount: state.maxMonthlyTransactionAmount!,
        deviceId: window.ReactNativeProps?.deviceId,
    };
    return updatePaymentLimits(request);
};
